import { z } from 'zod';
import { dateTimeSchema, uidSchema } from './shared';

export const commentDocumentSchema = z.object({
  id: z.string(),
  product_id: z.string(),
  replying_to: z.string().nullable().default(null),
  uid: uidSchema,
  comment: z.string().min(1).max(2000),
  created: dateTimeSchema.default(Date.now()),
  username: z.string().default(''),
  profile_picture: z.string().default(''),
  deleted: z.boolean().default(false),
});

export const postCommentInputSchema = z.object({
  product_id: z.string().min(1),
  comment: z.string().min(1).max(2000),
  replying_to: z.string().nullable().default(null),
});

export interface CommentDocument
  extends z.output<typeof commentDocumentSchema> {}
export interface PostCommentInput
  extends z.input<typeof postCommentInputSchema> {}
